import cloneDeep from 'lodash/cloneDeep';

import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { generateFormObject } from '@/core/tools/forms/generate_form_object';
import { prepareFormObjectForSave } from '@/core/tools/forms/prepare_form_object_for_save';
import moment from 'moment';

interface ShiftClotsFormState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;
    shift_plans: any[];
    form: any;
    forms: any[];
    schema: any;

    meta: any;
}

const state: ShiftClotsFormState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,
    shift_plans: [],
    form: null,
    forms: [],
    schema: null,

    meta: {},
};

const initState: ShiftClotsFormState = cloneDeep(state);

export const SHIFT_CLOTS_DATA = 'GET_SHIFT_CLOTS_DATA';
export const SHIFT_CLOTS_SCHEMA = 'GET_SHIFT_CLOTS_SCHEMA';

export const actions: ActionTree<ShiftClotsFormState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(SHIFT_CLOTS_DATA)
                    .raw('documents.get')
                    .action({
                        id: params.id
                    }),
            ]).then((result: ServerResult) => {
                commit('SET_FORM_DATA', result.getOperation(SHIFT_CLOTS_DATA).getContent());

                commit('LOADED_SUCCESS');
                resolve(null);
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    prepareNew({ commit, state }, initParams) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(SHIFT_CLOTS_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:shift_clot_vdp`
                    }),
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    ...result.getOperation(SHIFT_CLOTS_SCHEMA).getContent(),
                    initParams
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    saveForm({ commit }, documentId) {
        const vm = (this as any)._vm;

        const normalizedForm = prepareFormObjectForSave(state.schema, state.form);

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const saveQueries = state.forms.map((row: any) => {
                return row.filter((item: any) => {
                    return item.temp > 0;
                }).map((bucket: any) => {
                    const normalizedForm = prepareFormObjectForSave(state.schema, bucket);
                    return vm.$q('SHIFT_CLOTS_DATA_SAVE-' + bucket.row_number + '-' + bucket.bucket_number)
                        .create('s:shift_clot_vdp', normalizedForm)
                })
            }).flat(2);

            vm.$db(saveQueries).then(() => {
                commit('LOADED_SUCCESS');
                resolve(null);
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        })
    },

    changeFormValue({commit, state}, {field, newValue}) {
        commit('CHANGE_VALUE', {field, newValue});
        state.forms.map((row, row_idx) => {
            row.map((_: any, bucket_idx: any) => {
                commit('CHANGE_VALUE', {row: row_idx, bucket: bucket_idx, field, newValue});
            })
        })
    },

    changeFormValueForms({commit}, {row, bucket, field, newValue}) {
        commit('CHANGE_VALUE_FORM', {row, bucket, field, newValue});
    },

    getenrateForms({commit}, {row_count, bucket_count, starter_type_code}) {
        commit('GENERATE_FORMS', {row_count, bucket_count, starter_type_code});
    },

};

export const mutations: MutationTree<ShiftClotsFormState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = (initState as any)[key]
        }
    },

    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },

    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },

    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_SHIFT_CLOTS_DATA(state, {document}) {
        state.document = document;
    },

    SET_FORM_DATA(state, {document, schema}) {
        state.document = document;
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.form = generateFormObject(schema, state.document);
    },

    GENERATE_FORM_DATA(state, {schema, initParams}) {
        state.document = {};
        state.schema = schema;
        state.meta = fetchEnumsFromSchema(schema);

        state.form = generateFormObject(schema, initParams);
    },

    GENERATE_FORMS(state, {row_count, bucket_count, starter_type_code}) {
        state.forms = []
        for(let i: number = 0; i < row_count; i++) {
            state.forms[i] = [];
            for(let j: number = 0; j < bucket_count; j++) {
                state.forms[i][j] = generateFormObject(state.schema, {
                    ...state.form,
                    starter_type_code: starter_type_code,
                    row_number: '' + (i + 1),
                    bucket_number: '' + (j + 1)
                });
            }
        }
    },

    ON_FORM_SAVE(state, {document, schema}) {
        state.document = document;
        state.schema = schema;

        state.form = generateFormObject(schema, state.document);
    },

    CHANGE_VALUE(state: ShiftClotsFormState, {field, newValue}) {
        const schema_field = state.schema.fields.filter((item: any) => {
            return item.code == field
        })[0]

        if (schema_field && (schema_field.type == 'decimal')) {
            console.log('newValue', newValue)
            newValue = parseFloat(newValue.replace(',', '.'))
            console.log('newValue', newValue)
        }
        switch (field) {
            case 'datetime':
                state.form[field] = moment(newValue).utc().local().format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                state.form[field] = newValue;
        }

    },

    CHANGE_VALUE_FORM(state: ShiftClotsFormState, {row, bucket, field, newValue}) {
        const schema_field = state.schema.fields.filter((item: any) => {
            return item.code == field
        })[0]

        if (schema_field && (schema_field.type == 'decimal') && typeof newValue == 'string') {
            newValue = parseFloat(newValue.replace(',', '.'))
        }
        switch (field) {
            case 'datetime':
                state.forms[row][bucket][field] = moment(newValue).utc().local().format('YYYY-MM-DD HH:mm:ss');
                break;
            default:
                state.forms[row][bucket][field] = newValue;
        }
    },
};

const getters = {
    fields: (state: ShiftClotsFormState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_shift_vdp_clots_multi_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
